import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HeaderNotificationsMenu from "./HeaderNotificationsMenu";
import {
  MemberMenuRoot,
  MemberMenuTrigger,
  MemberAvatar,
  MemberAvatarFallback,
  MemberMenuName,
  MemberMenuPanel,
  MemberMenuIdentity,
  MemberMenuIdentityText,
  MemberMenuIdentityName,
  MemberMenuIdentityEmail,
  MemberMenuActions,
  MemberMenuAction,
  MemberMenuActionIcon,
  MemberMenuActionLabel,
} from "./Header.styles";

const getUserFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

const getInitials = (name = "") =>
  name
    .split(" ")
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

const renderAvatar = (user, initials, large = false) => {
  if (user?.avatar?.small) {
    return <MemberAvatar src={user.avatar.small} alt="" $large={large} />;
  }

  return (
    <MemberAvatarFallback $large={large}>{initials}</MemberAvatarFallback>
  );
};

const HeaderMemberMenu = () => {
  const navigate = useNavigate();
  const wrapperRef = useRef(null);
  const user = getUserFromStorage();
  const [open, setOpen] = useState(false);

  const initials = getInitials(user?.name);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  if (!user) return null;

  const closeMenu = () => setOpen(false);

  const handleLogout = () => {
    closeMenu();
    localStorage.clear();
    navigate("/");
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  return (
    <>
      <HeaderNotificationsMenu />

      <MemberMenuRoot ref={wrapperRef}>
        <MemberMenuTrigger
          type="button"
          aria-expanded={open}
          aria-haspopup="true"
          aria-label="Open member menu"
          onClick={() => setOpen((value) => !value)}
        >
          {renderAvatar(user, initials)}
          <MemberMenuName>{user.name}</MemberMenuName>
          <span className="material-icons" aria-hidden="true">
            expand_more
          </span>
        </MemberMenuTrigger>

        {open && (
          <MemberMenuPanel role="menu">
            <MemberMenuIdentity>
              {renderAvatar(user, initials, true)}
              <MemberMenuIdentityText>
                <MemberMenuIdentityName>{user.name}</MemberMenuIdentityName>
                <MemberMenuIdentityEmail>{user.email}</MemberMenuIdentityEmail>
              </MemberMenuIdentityText>
            </MemberMenuIdentity>

            <MemberMenuActions>
              <MemberMenuAction
                as={Link}
                to="/user-profile"
                role="menuitem"
                onClick={closeMenu}
              >
                <MemberMenuActionIcon>
                  <span className="material-icons" aria-hidden="true">
                    person
                  </span>
                </MemberMenuActionIcon>
                <MemberMenuActionLabel>Profile</MemberMenuActionLabel>
              </MemberMenuAction>

              <MemberMenuAction
                as="button"
                type="button"
                role="menuitem"
                onClick={handleLogout}
              >
                <MemberMenuActionIcon>
                  <span className="material-icons" aria-hidden="true">
                    logout
                  </span>
                </MemberMenuActionIcon>
                <MemberMenuActionLabel $danger>Logout</MemberMenuActionLabel>
              </MemberMenuAction>
            </MemberMenuActions>
          </MemberMenuPanel>
        )}
      </MemberMenuRoot>
    </>
  );
};

export default HeaderMemberMenu;
